<template>
    <li
        :class="['circle_item', 'h_agq_page_li',
            {
                is_master: (msg.user_id == circleData.chat_room_user_id) || liveDefault == 'my_msg',
            }
        ]"
    >
        <div
            class="h_agq_page_li_image"
            @click.stop.prevent="goDetail"
        >
            <img :src="msg.avatar" alt="头像">
        </div>
        <div :class="['h_agq_page_li_box']">
            <div class="h_agq_page_li_wrap" @click.prevent="showChattingHover">
                <div class="h_agq_page_li_info">
                    <span class="h_agq_page_li_name">{{ msg.nickname }}{{ user_id == msg.user_id ? '(我)' : '' }}</span>
                    <span class="h_agq_page_li_id" v-if="msg.user_id == circleData.chat_room_user_id">老师</span>
                    <span v-if="msg.buy_vip_number" class="h_agq_page_li_fan">{{ fanName + msg.buy_vip_number }}</span>
                    <span class="h_agq_page_li_time">{{ rec_time(msg.create_time) + '&nbsp;' + msg.user_ip_location }}</span>
                </div>
                <div :class="['h_agq_page_li_content']">
                    <div
                        class="h_agq_page_li_re_content"
                        v-if="msg.origin_id && msg.origin_data && msg.origin_data.id"
                    >
                        <p class="h_agq_page_li_re_name">@{{ msg.origin_nickname }}</p>
                        <img
                            class="h_agq_page_li_re_content_img h_agq_page_li_img"
                            v-if="msg.origin_data.content_type == 2 && type == 'app_circle'"
                            :src="imgInfo('url', msg.origin_data.images_json)"
                            @click.stop.prevent="viewImg(imgInfo('url', msg.origin_data.images_json))"
                            :style="domStyle(imgInfo('url', msg.origin_data.images_json), msg.origin_data, 'image-text')"
                        />
                        <img
                            class="h_agq_page_li_re_content_img h_agq_page_li_img"
                            v-if="msg.origin_data.content_type == 2 && type != 'app_circle'"
                            :src="imgInfo('url', msg.origin_data.images_json)"
                            @load="$previewRefresh"
                            :preview="randomStr"
                            :style="domStyle(imgInfo('url', msg.origin_data.images_json), msg.origin_data, 'image-text')"
                        />
                        <p v-else class="h_agq_page_li_re_content_box" v-html="reStrParse"></p>
                        <img
                            class="h_agq_page_li_re_content_img h_agq_page_li_img rp_img"
                            v-if="msg.origin_data.content_type == 4 && type == 'app_circle'"
                            :src="imgInfo('url', msg.origin_data.images_json)"
                            @click.stop.prevent="viewImg(imgInfo('url', msg.origin_data.images_json))"
                            :style="domStyle(imgInfo('url', msg.origin_data.images_json), msg.origin_data, 'image-text')"
                        />
                        <img
                            class="h_agq_page_li_re_content_img h_agq_page_li_img rp_img"
                            v-if="msg.origin_data.content_type == 4 && type != 'app_circle'"
                            :src="imgInfo('url', msg.origin_data.images_json)"
                            @load="$previewRefresh"
                            :preview="randomStr"
                            :style="domStyle(imgInfo('url', msg.origin_data.images_json), msg.origin_data, 'image-text')"
                        />
                    </div>
                    <div class="h_agq_page_li_content_box" :class="[{ bindOriginId: msg.origin_id }]">
                        <img
                            v-if="msg.content_type == 2 && type == 'app_circle'"
                            class='h_agq_page_li_img'
                            :src="imgInfo('url', msg.images_json)"
                            @click.stop.prevent="viewImg(imgInfo('url', msg.images_json))"
                            :style="domStyle(imgInfo('url', msg.images_json), msg, 'image-text')"
                        />
                        <img
                            v-if="msg.content_type == 2 && type != 'app_circle'"
                            class='h_agq_page_li_img'
                            :src="imgInfo('url', msg.images_json)"
                            @load="$previewRefresh"
                            :preview="randomStr"
                            :style="domStyle(imgInfo('url', msg.images_json), msg, 'image-text')"
                        />
                        <p v-else v-highlight="strParse"></p>
                        <img
                            v-if="msg.content_type == 4 && type == 'app_circle'"
                            class='h_agq_page_li_img rp_img'
                            :src="imgInfo('url', msg.images_json)"
                            :style="domStyle(imgInfo('url', msg.images_json), msg, 'image-text')"
                            @click.stop.prevent="viewImg(imgInfo('url', msg.images_json))"
                        />
                        <img
                            v-if="msg.content_type == 4 && type != 'app_circle'"
                            class='h_agq_page_li_img rp_img'
                            :src="imgInfo('url', msg.images_json)"
                            @load="$previewRefresh"
                            :preview="randomStr"
                            :style="domStyle(imgInfo('url', msg.images_json), msg, 'image-text')"
                        />
                    </div>
                </div>

                <!-- 滑过 - 菜单 -->
                <div
                    class="h_agq_page_li_hover"
                    v-if="liveDefault != 'my_msg' && isCloseInteraction && showChattingIndex == index"
                >
                    <button @click.stop.prevent="replyUserFn(msg, index)">回复</button>
                    <button
                        v-if="isAdmins || (user_id == msg.user_id)"
                        @click.stop.prevent="delChattingRoomItemFn(msg)"
                    >撤回</button>
                    <button
                        v-if="msg.user_id != circleData.chat_room_user_id && isAdmins"
                        @click.stop.prevent="blackChattingRoomItemFn(msg, index)"
                    >拉黑</button>
                </div>
            </div>
            <div
                class="h_agq_page_li_tips"
                v-if="liveDefault != 'my_msg' && msg.user_id == circleData.chat_room_user_id"
            >
                <p>本观点仅供参考，自主决策，风险自担！</p>
            </div>
        </div>

        <div v-if="liveDefault == 'my_msg'" class="h_agq_page_chatting_menu">
            <!-- 回复 -->
            <template v-if="isAdmins && liveDefault == 'my_msg'">
                <button v-if="msg.state !== 1 && msg.is_reply == 1" class="bind_pass">已回复</button>
                <button
                    v-else-if="msg.state !== 1 && msg.is_reply != 1"
                    @click.stop.prevent="replyUserFn(msg, index)"
                >回复</button>
            </template>
            <template v-else>
                <button v-if="msg.state !== 1" @click.stop.prevent="replyUserFn(msg, index)">回复</button>
            </template>

            <!-- 通过状态 - 老师展示 仅在“我的消息”中 -->
            <button
                v-if="liveDefault == 'my_msg' && isAdmins && stateFn"
                :class="{
                    bind_pass: msg.state == 0
                }"
                @click.stop.prevent="liveChattingPassMsgFn(msg)"
            >{{ stateFn(msg.state, 'admins') }}</button>

            <!-- 删除 - 老师和发布者可以看到 -->
            <button
                v-if="(isAdmins || (user_id == msg.user_id) || isAdmins) && msg.state <= 1"
                @click.stop.prevent="delChattingRoomItemFn(msg, 'right')"
            >删除</button>
            <button
                v-if="(isAdmins || (user_id == msg.user_id) || isAdmins) && msg.state > 1"
                class="bind_pass"
            >已删除</button>
        </div>
    </li>
</template>

<script>
import { Dialog } from "vant";
import circleApi from "@/api/circle/index.js";
import { rec_time, funNameFn } from "@/utils/publicCommon";

export default {
    name: "CircleListItem",
    components: {

    },
    props: {
        msg: Object,
        index: Number,
        circleData: Object, // 圈子信息
        user_id: [Number, String],//登录用户id
        tagType: String, // 标签名字
        showChattingIndex: [Number, String], //展示滑过隐藏的下标索引
        cureentDefault: String,
        isAdmins: [Boolean],
        isCloseInteraction: Boolean, // 是否开启交互
        liveDefault: String, // 默认选中类型，如果是my_list 默认左侧布局
        type: String, // 来源
    },
    data() {
        return {
            randomStr: Math.random().toString(36).slice(-4),
            pageLoading: false,
            faceList: { "\u5fae\u7b11": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_weixiao@3x.png", "\u9707\u60ca": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_zhenjing@3x.png", "\u6487\u5634": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_piezui@3x.png", "\u8272": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_se@3x.png", "\u5927\u54ed": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_daku@3x.png", "\u9177": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_ku@3x.png", "\u594b\u6597": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_fendou@3x.png", "\u7591\u95ee": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_yiwen@3x.png", "\u574f\u7b11": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_huaixiao@3x.png", "\u9634\u9669": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_yinxian@3x.png", "\u4eb2\u4eb2": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_qinqin@3x.png", "\u53ef\u601c": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_kelian@3x.png", "OK": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_OK@3x.png", "\u98de\u543b": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_feiwen@3x.png", "\u60b2\u4f24": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_beishang@3x.png", "\u6c57": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_han@3x.png", "\u6342\u8138": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_wulian@3x.png", "\u5927\u6012": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_danu@3x.png", "\u6012\u706b": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_nuhuo@3x.png", "\u5455": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_ou@3x.png", "dog": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_dog@3x.png", "\u94b1": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_qian@3x.png", "\u5410\u8840": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_tuxue@3x.png", "\u6342\u5634\u7b11": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_wuzuixiao@3x.png", "\u61f5": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_meng@3x.png", "\u53cb\u5584": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_youshan@3x.png", "\u60e8": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_can@3x.png", "\u4e27": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_sang@3x.png", "\u6311\u7709": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_tiaomei@3x.png", "\u7b11\u54ed": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_xiaoku@3x.png", "\u7761\u89c9": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_shuijiao@3x.png", "\u53ef\u7231": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_keai@3x.png", "\u5657": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_pu@3x.png", "\u6c14\u6124": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_qifen@3x.png", "\u5927\u7b11": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_daxiao@3x.png", "\u611f\u5192\u4e86": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_kouzhao@3x.png", "\u5201\u96be": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_diaonan@3x.png", "\u67e0\u6aac": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_ningmeng@3x.png", "\u771f\u725b": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_zhenniu@3x.png", "\u65e9\u5b89": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_zaoan@3x.png", "\u665a\u5b89": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_wanan@3x.png", "\u7a7a\u4ed3": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_kongcang@3x.png", "\u6ee1\u4ed3": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_mancang@3x.png", "\u51cf\u4ed3": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_jiancang@3x.png", "\u52a0\u4ed3": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_jiacang@3x.png", "\u6da8": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_zhang@3x.png", "\u8dcc": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_die@3x.png", "\u8e29": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_cai@3x.png", "\u9876": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_ding@3x.png", "\u80dc\u5229": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_shengli@3x.png", "\u91d1\u5e01": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/face_jinbi@3x.png", "dog\u6342\u8138": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/dog_wulian2021-08-23@3x.png", "dog\u7b11\u54ed": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/dog_xiaoku2021-08-23@3x.png", "\u7231\u5fc3": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/aixin2021-08-23@3x.png", "\u5315\u9996": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/bishou2021-08-23@3x.png", "\u6284\u5e95": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/chaodi2021-08-23@3x.png", "\u5403\u74dc": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/chigua2021-08-23@3x.png", "\u5403\u8089": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/chirou2021-08-23@3x.png", "\u6253call": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/dacall2021-08-23l@3x.png", "\u4e8c\u54c8": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/erha2021-08-23@3x.png", "\u7ea2\u5305": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/hongbao2021-08-23@3x.png", "\u97ed\u83dc": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/jiucai2021-08-23@3x.png", "\u9152": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/jiu2021-08-23@3x.png", "\u88c2\u5f00": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/liekai2021-08-23@3x.png", "\u5e72\u676f": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/pijiu2021-08-23@3x.png", "\u5e86\u795d": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/qingzhu2021-08-23@3x.png", "\u5fc3\u788e": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/xinsui2021-08-23@3x.png", "\u836f": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/yao2021-08-23@3x.png", "666": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/666_v3.png", "\u767d\u773c": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/baiyan_v3.png", "\u6253\u8138": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/dalian_v3.png", "\u9f13\u638c": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/guzhang_v3.png", "\u62a0\u9f3b": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/koubi_v3.png", "\u96be\u8fc7": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/nanguo_v3.png", "\u53f9\u6c14": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/tanqi_v3.png", "\u6293\u72c2": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/zhuakuang_v3.png", "\u9f87\u7259": "https:\/\/cdncos.aigupiao.com\/assets\/pc\/img\/agp_face\/ziya_v3.png", "\u4e70": "https:\/\/img1-cdn-picsh.aigupiao.com\/m\/image_lib\/2022-03-21\/0e2f6f9ac9666b0cbf46bbf18fb15528=200X200.png", "\u8df3\u6c34": "https:\/\/img1-cdn-picsh.aigupiao.com\/m\/image_lib\/2022-03-21\/d938c427247c2c9dfc0c0ff3edee75ed=200X200.png", "\u7a7a": "https:\/\/img1-cdn-picsh.aigupiao.com\/m\/image_lib\/2022-03-21\/7b5cc2714dc25772900d3c8924237b22=200X200.png", "\u591a": "https:\/\/img1-cdn-picsh.aigupiao.com\/m\/image_lib\/2022-03-21\/4fe79dc6598e28957f02439e81eb7a68=200X200.png", "\u5403\u9762": "https:\/\/img1-cdn-picsh.aigupiao.com\/m\/image_lib\/2022-03-21\/140199629c06eca7f7f4c63cec870bd0=200X200.png", "\u68ad\u54c8": "https:\/\/img1-cdn-picsh.aigupiao.com\/m\/image_lib\/2022-03-21\/90cb956f181acaf875b1c7a857937112=200X200.png", "\u5356": "https:\/\/img1-cdn-picsh.aigupiao.com\/m\/image_lib\/2022-03-21\/2263373d61c164c7ecd0d2551dc82323=200X200.png", "\u62b1\u62f3": "https:\/\/img1-cdn-picsh.aigupiao.com\/m\/image_lib\/2022-03-21\/f838a3021272c8fdfc580ad8992be7a7=100X100.png", "\u7948\u7977": "https:\/\/img1-cdn-picsh.aigupiao.com\/m\/image_lib\/2022-03-21\/cf0006b5b512a9e8d3946b19166d28c2=100X100.png", "\u63e1\u624b": "https:\/\/img1-cdn-picsh.aigupiao.com\/m\/image_lib\/2022-03-21\/e2d6ab55fc734846651fddf0fb363a06=100X100.png" },
            fanName: '铁粉',//粉丝名称
        };
    },
    created() {
        // this.fanName = funNameFn(this.circleData.id);
    },
    mounted() {

    },
    computed: {
        // 字符串
        strParse() {
            return this.strParseFace(this.msg.content.replace(/\n/gi, "<br />"));
        },
        // 回复字符串
        reStrParse() {
            return this.strParseFace(this.msg.origin_data.content.replace(/\n/gi, "<br />"));
        }
    },
    methods: {
        rec_time,
        viewImg(src) {
            let img = [{
                type: "image",
                img_url: src
            }]
            this.$srBrowserMedia(0, img);
        },
        // 跳转某个用户的详情页
        goDetail() {
            if(this.isCloseInteraction) {
                let item = this.msg;
                let circleData = this.circleData;

                if(this.type == 'app_circle') {
                    this.openNative('chatting_room', {
                        url: `/up/app/chattingRoom/${circleData.chat_room_live_id}/${item.user_id}/${item.nickname}`
                    });
                } else {
                    location.href = `/up/chattingRoom/${circleData.chat_room_live_id}/${item.user_id}/${item.nickname}`;
                }
                
            }
        },
        // 跳转APP页面
        openNative(type, query = {}) {
            let params = {
                kind: type, // 类型
            };

            // 同步传参
            params = {
                ...params,
                ...query
            }

            this.$srH5CallNativeMethodApp('call_Native',params)
        },
        // 字符串替换
        strParseFace(_str) {
            let json = this.faceList || [];
            let pattern1 = /\[.+?\]/g;
            let pattern2 = /\[.+?\]/;
            let contents = _str;
            let content = contents.match(pattern1);
            let str = contents;

            if (content && Object.keys(json).length > 0) {
                for (let i = 0; i < content.length; i++) {
                    let src = "";
                    for (let item in json) {
                        if ("[" + item + "]" === content[i]) {
                            src = `<img class="AGP_face" render="ext" src="${json[item]}" alt="${item}" title="${item}" type="face">`;
                            break;
                        }
                    }
                    if (src) {
                        str = str.replace(pattern2, src);
                    }
                }
            } else {
                return str;
            }

            return str;
        },
        // 删除聊天室对话
        async delChattingRoomItemFn(item) {
            let _this = this;
            if (_this.pageLoading) {
                return
            }
            _this.pageLoading = true;

            let data = {
                id: item.id,
                chat_room_live_id: this.id
            }

            if (item.user_id == this.user_id) {
                data.del_type = 1;
            } else {
                data.del_type = 0;
            }
            let res = await circleApi.delete_message({
                ...data
            })
            if (res.code == 1) {
                _this.$message.success("撤回成功！");
                _this.$emit('chattingClick', {
                    type: "delItem",
                    item: _this.msg,
                    index: _this.index
                })
            }
            else {
                _this.$message.error(res.message);
            }
            _this.pageLoading = false;
        },
        // 直播样式 - 右侧 - 通过审核用户消息
        async liveChattingPassMsgFn(item) {
            if (item.state !== 1) return;
            let res = await circleApi.audit_chat_message({
                "user_id": this.user_id,
                "msg_id": item.id,
            })

            if (res.code == 1) {
                this.$message.success("操作成功");
                this.$set(this.msg, 'state', 0);
            } else {
                this.$message.error(res.message);
            }
            this.pageLoading = false;
        },
        // 消息对应的文案
        stateFn(state, type) {
            let _str = "";
            if (type == 'admins') {
                switch (state) {
                    case 0: _str = '已通过'; break;
                    case 1: _str = '通过'; break;
                }
            }

            // 消息状态：0->正常；1->待审核；2->主动撤回；3->用户自己删除；4->圈主或管理员删除；5->cms删除'

            return _str;
        },
        // 圈主拉黑聊天室用户
        async blackChattingRoomItemFn(item) {
            let _this = this;
            if (_this.pageLoading) {
                return
            }
            _this.pageLoading = true;

            let data = {
                user_id: this.user_id,
                black_user_id: item.user_id,
            }

            let res = await circleApi.add_black({
                ...data
            })

            if (res.code == 1) {
                _this.$message.success("拉黑成功！");
            }
            else {
                _this.$message.error(res.message);
            }
            _this.$emit('chattingClick', {
                type: "closeItem",
                item: _this.msg,
                index: _this.index
            })
            _this.pageLoading = false;
        },
        // 点击回复某用户
        replyUserFn() {
            this.$emit('chattingClick', {
                type: "reply_user",
                item: this.msg,
                index: this.index
            })
        },
        // 展示 聊天室列表
        showChattingHover() {
            if (this.isCloseInteraction) {
                this.$emit('chattingClick', {
                    type: "showTab",
                    item: this.msg,
                    index: this.index
                })
            }
        },
        imgInfo(type, info) {
            let img = null;
            if (info) {
                img = JSON.parse(info)
            }
            return img && img[type]
        },
        // 返回DOM宽高
        domStyle(url, item, type) {
            let _style = {};
            let _obj = {};
            if (type == 'image-text') {
                _obj = {
                    _w: this.imgInfo('_width', item.images_json),
                    _h: this.imgInfo('_height', item.images_json),
                }
            }
            else if (!item._width) {
                if (url.indexOf('https') > -1) {
                    _obj = this.interceptWidthAndHeight(url)
                }
            } else {
                _obj = {
                    _w: item._width,
                    _h: item._height
                }
            }
            if (_obj && Object.keys(_obj).length > 0) {
                let _wd = document.body.clientWidth;
                _wd = _wd * 0.8
                if (_obj._w > _wd) {
                    let _oc = _obj._h / _obj._w;
                    _obj._h = (_oc * _wd);
                    _obj._w = _wd;
                }

                if (_obj._w) {
                    _style.width = _obj._w + 'px'
                }


                if (_obj._h) {
                    _style.height = _obj._h + 'px'
                }
            }

            return _style
        },
        // 截取宽高
        interceptWidthAndHeight(str) {
            let _str = str.split('=')[1].split('.')[0], _w = 0, _h = 0;
            if (_str) {
                _w = _str.split('X')[0];
                _h = _str.split('X')[1];
            }
            return {
                _w,
                _h
            }
        }
    },
    directives: {
        highlight: {
            bind(el, binding, vnode) {
                let _str = binding.value;
                if (_str !== null) {
                    // _str = _str.replace(/([hH][tT]{2}[pP]:\/\/|[hH][tT]{2}[pP][sS]:\/\/|[wW]{3}.|[wW][aA][pP].|[fF][tT][pP].|[fF][iI][lL][eE].)[-A-Za-z0-9+&@#\/%?=~_|!:,.;]+[-A-Za-z0-9+&@#\/%=~_|]/img, match => {
                    //     if (match.indexOf('aigupiao.com') > -1) {
                    //         const wrapper = document.createElement('a');
                    //         wrapper.className = "p-a-link";
                    //         if (match.indexOf("http") == -1) {
                    //             wrapper.href = "https://" + match;
                    //         } else {
                    //             wrapper.href = match;
                    //         }
                    //         wrapper.target = "_blank";
                    //         wrapper.textContent = match;
                    //         return wrapper.outerHTML;
                    //     } else {
                    //         return match;
                    //     }
                    // });
                }
                el.innerHTML = _str;
            }
        }
    },
};
</script>

<style scoped lang="scss">
li.circle_item {
    padding: 8px 12px 0;
    margin-top: 3px;
    background: #ffffff;
    position: relative;

    &.h_agq_page_li {
        display: flex;
        flex-direction: row-reverse;
        justify-content: flex-start;
        margin-bottom: 20px;
        border-bottom: none;
        background-color: #F5F6F7;

        .h_agq_page_li_fan {
            border-radius: 4px;
            background: linear-gradient(277deg, #FF8463 5.15%, #F8513E 94.85%);
            display: inline-flex;
            padding: 2px 3px;
            justify-content: center;
            align-items: center;
            color: #FFF !important;
            font-size: 10px !important;
            line-height: 10px !important;
        }

        // 老师
        &.is_master {
            flex-direction: row;

            .h_agq_page_li_box {
                padding: 0 0 0 9px;
                margin: 0 43.5px 0 0;
                justify-content: flex-start;

                .h_agq_page_li_wrap {
                    position: relative;

                    .h_agq_page_li_hover {
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: unset;
                    }

                    .h_agq_page_li_info {
                        flex-direction: row;
                        justify-content: flex-start;

                        .h_agq_page_li_name {
                            margin-right: 3.5px;
                        }

                        // 单条内容 是否是圈主
                        .h_agq_page_li_id {
                            background-color: #48A0FF;
                            height: 14px;
                            line-height: 14px;
                            padding: 0 3px;
                            box-sizing: border-box;
                            width: auto;
                            color: #FFFFFF;
                            font-size: 10px;
                            font-weight: 300;
                            border-radius: 2px;
                        }

                        .h_agq_page_li_time {
                            font-size: 12px;
                            line-height: 16.5px;
                            color: #939393;
                            margin: 0 0 0 10px;
                        }
                    }

                    .h_agq_page_li_content {
                        background-color: #B8E4FF;
                        float: left;
                        padding: 7.5px 12px 11px;

                        .h_agq_page_li_content_box {
                            justify-content: flex-start;

                            &.bindOriginId {
                                padding: 5px 0 0 0;
                            }
                        }

                        .h_agq_page_li_re_content {
                            border-bottom: 0.5px solid #A2C8DF;
                            padding: 0 0 9px 0;
                            position: relative;

                            .h_agq_page_li_re_name {
                                font-size: 14px;
                                line-height: 22px;
                                color: #3589E5;
                                margin-bottom: 2px;
                            }

                            .h_agq_page_li_re_content_box {
                                font-size: 14px;
                                line-height: 20px;
                                color: #636363;
                            }
                        }
                    }
                }

                .h_agq_page_li_tips {
                    font-size: 11px;
                    line-height: 15px;
                    color: #B6B6B6;
                    user-select: none;
                    font-weight: normal;
                    margin-top: 5px;
                }
            }
        }

        // 头像样式
        .h_agq_page_li_image {
            width: 32px;
            height: 32px;
            border-radius: 50%;
            overflow: hidden;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                display: block;
                background-color: transparent;
            }
        }

        // 单条内容样式
        .h_agq_page_li_box {
            flex: 1;
            overflow: hidden;
            width: auto;
            height: auto;
            padding-right: 9px;
            box-sizing: border-box;
            display: grid;
            flex-direction: column;
            justify-content: flex-end;
            margin-left: 43px;

            .h_agq_page_li_wrap {
                position: relative;

                .h_agq_page_li_hover {
                    position: absolute;
                    top: 0;
                    right: 0;
                    width: auto;
                    height: auto;
                    background-color: rgb(69, 69, 69);
                    border-radius: 4px;
                    display: inline-flex;
                    flex-direction: row;

                    &::before {
                        content: "";
                        position: absolute;
                        left: 50%;
                        transform: translateX(-4px);
                        bottom: -8px;
                        width: 0;
                        height: 0;
                        border: 4px solid transparent;
                        border-top-color: rgb(69, 69, 69);
                    }

                    button {
                        background-color: transparent;
                        border: none;
                        outline: none;
                        font-size: 12px;
                        line-height: 16.5px;
                        color: #F5F6F7;
                        font-weight: normal;
                        user-select: none;
                        padding: 2.5px 7px 2.5px;
                        box-sizing: border-box;
                        cursor: pointer;
                        white-space: nowrap;

                        &:hover {
                            opacity: .8;
                        }
                    }
                }

                // 单条内容的信息
                .h_agq_page_li_info {
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-end;
                    align-items: center;
                    margin-bottom: 8px;

                    // 单条内容的用户名字
                    .h_agq_page_li_name {
                        font-size: 13px;
                        line-height: 18.5px;
                        color: #636363;
                        margin-right: 3.5px;
                    }

                    .h_agq_page_li_time {
                        font-size: 12px;
                        line-height: 16.5px;
                        color: #939393;
                        margin-left: 10px;
                    }
                }

                // 单条内容
                .h_agq_page_li_content {
                    display: inline-block;
                    box-sizing: border-box;
                    background-color: #FFFFFF;
                    border-radius: 4px;
                    float: right;
                    padding: 9.5px 11px 9.5px 13px;

                    .h_agq_page_li_content_box {
                        padding-top: 5px;
                        display: flex;
                        flex-direction: column;
                        justify-content: flex-start;

                        p {
                            font-size: 15px;
                            line-height: 22px;
                            color: #333333;
                            font-weight: normal;
                        }

                        img {
                            max-width: 100%;
                            height: auto !important;
                            display: block;
                        }

                        .rp_img {
                            // max-width: 100%;
                            display: block;
                        }
                    }

                    .h_agq_page_li_re_content {
                        border-bottom: 0.5px solid #A2C8DF;
                        padding: 0 0 9px 0;
                        position: relative;

                        .h_agq_page_li_re_name {
                            font-size: 14px;
                            line-height: 22px;
                            color: #3589E5;
                            margin-bottom: 2px;
                        }

                        .h_agq_page_li_re_content_box {
                            font-size: 14px;
                            line-height: 20px;
                            color: #636363;
                        }

                        img {
                            max-width: 100%;
                        }

                        .rp_img {
                            // max-width: 100%;
                            display: block;
                        }
                    }
                }
            }
        }
    }
}

li.circle_item:first-child {
    margin-top: 0;
}

.h_agq_page_chatting_menu {
    position: absolute;
    right: 10px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    flex-wrap: wrap;
    width: auto;
    /* 92px */

    button {
        font-size: 12px;
        height: 20px;
        color: #1D88D0;
        margin-left: 4px;
        background-color: transparent;
        border: none;
        padding: 0;
        cursor: pointer;
        outline: none;

        &:first-of-type {
            margin-left: 0;
        }

        &.bind_pass {
            color: #939393;
            cursor: default;
        }
    }
}
</style>

<style lang="scss">
.AGP_face {
    width: 20px;
    height: 20px;
    vertical-align: sub;
}

.p-a-link {
    word-break: break-all;
    overflow-wrap: break-word;
}

.van-dialog.del {
    width: 320px;
    font-size: 16px;
    border-radius: 16px;

    .van-dialog__content--isolated {
        min-height: 104px;
    }

    .van-dialog__message {
        padding: 26px 24px;
        font-size: 18px;
        line-height: 20px;
    }

    .van-dialog__cancel,
    .van-dialog__confirm {
        height: 48px;
        border-radius: 2px;
    }

    .van-button__text {
        font-size: 15px;
    }
}
</style>